import React from 'react';
import { IMPORT_EXPORT_STATUS } from '@brighterion/utils/constants';
import { useTranslation } from 'react-i18next';

const useGetSidePanelContentCardHelperData = (data: SidePanelAccordionItemContentCardData) => {
    const [isHelperDataAvailable, setIsHelperDataAvailable] = React.useState<boolean>(false);
    const { t } = useTranslation();
    const status = data?.status?.type;

    const isFromQueuedSection = status === IMPORT_EXPORT_STATUS.IN_PROGRESS;
    const isFailed = status === IMPORT_EXPORT_STATUS.FAILED;
    const isFinished = status === IMPORT_EXPORT_STATUS.FINISHED;

    const noOfRecords = data?.progressDetails?.noOfRecords ?? 0;
    const hasStartedProcessing = noOfRecords > 0;

    const shouldShowHelperData = (isFailed && hasStartedProcessing) || isFinished || isFromQueuedSection;

    const getHelperTableProps = React.useCallback(() => {
        const props = {
            ...(hasStartedProcessing
                ? {
                      noOfRecords
                  }
                : undefined),
            importFilename: isFromQueuedSection ? data.fileName : data.progressDetails?.importFilename
        };
        return props;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.progressDetails, isFinished]);

    const helperChildContentTitle = React.useCallback(() => {
        if (isFailed) {
            return data.progressDetails?.jobError;
        }
        return t('Import Details');
    }, [data.progressDetails, isFailed, t]);

    const helperChildContent = React.useCallback(() => {
        const title = helperChildContentTitle();
        const titleIcon = isFailed ? 'exclamation-triangle-outline' : 'info';
        const isError = isFailed;
        const helperTableProps = getHelperTableProps();
        if (title && shouldShowHelperData) {
            return { title, titleIcon, isError, helperTableProps };
        }
        if ((title && isFailed) || isFromQueuedSection) {
            return { title, titleIcon, isError };
        }
        return null;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [helperChildContentTitle, isFailed, shouldShowHelperData]);

    const getHelperData = React.useCallback(() => {
        const helperData = helperChildContent();
        if (helperData) {
            setIsHelperDataAvailable(true);
        } else {
            setIsHelperDataAvailable(false);
        }
        return helperData;
    }, [helperChildContent]);
    return { getHelperData, isHelperDataAvailable };
};

export default useGetSidePanelContentCardHelperData;
